import React from 'react'

import { ReactComponent as RefreshIcon } from '../../../../../../assets/icons/refresh.svg'

import Button from '../../../../../../components/Button'
import Icon from '../../../../../../components/Icon'
import Loader from '../../../../../../components/Loaders/Loader'

import useStyles from './styles'

const CheckNewPostsButton = ({ isLoading, onRefreshButtonClickHandler }) => {
  const classes = useStyles()

  return (
    <Button className={classes.refreshButton} onClick={onRefreshButtonClickHandler}>
      <Icon className={classes.refreshButtonIcon}>{isLoading ? <Loader /> : <RefreshIcon />}</Icon>
      Check for new posts
    </Button>
  )
}

export default CheckNewPostsButton
